import { WithAccountId } from '@mews-commander/types';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { ProcessPaymentType } from '../ProcessPaymentType';
import { getPaymentTypesEnabledSetting } from '../utils';

export const useGetPaymentTypesEnabledSettingSuspense = ({
    accountId,
}: WithAccountId): Record<ProcessPaymentType, boolean | undefined> => {
    const { data } = useRepositorySuspenseQuery('paymentMethods', 'getAvailability', { accountId });
    return getPaymentTypesEnabledSetting(data);
};
